module.exports = __webpack_public_path__ + "img/4.103b5cf2.jpg";